"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECAPTCHA_ACTIONS = exports.HCAPTCHA_SIZES = exports.CAPTCHA_STARTED = exports.CAPTCHA_PROVIDERS = exports.CAPTCHA_FRICTION_MODES = exports.CAPTCHA_CONCLUSION = exports.CAPTCHA_COMPLETED = exports.CAPTCHA_CHALLENGE_OPENED = void 0;
var CAPTCHA_FRICTION_MODES = Object.freeze({
  LOW: "low",
  HIGH: "high"
});
exports.CAPTCHA_FRICTION_MODES = CAPTCHA_FRICTION_MODES;
var CAPTCHA_PROVIDERS = Object.freeze({
  HCAPTCHA: "hcaptcha",
  RECAPTCHA: "recaptcha"
});
exports.CAPTCHA_PROVIDERS = CAPTCHA_PROVIDERS;
var HCAPTCHA_SIZES = Object.freeze({
  NORMAL: "normal",
  INVISIBLE: "invisible"
});
exports.HCAPTCHA_SIZES = HCAPTCHA_SIZES;
var CAPTCHA_CONCLUSION = Object.freeze({
  SUCCESS: "success",
  FAIL: "fail",
  DISMISSED: "dismissed",
  EXPIRED: "expired"
});
exports.CAPTCHA_CONCLUSION = CAPTCHA_CONCLUSION;
var RECAPTCHA_ACTIONS = {
  GENERIC_5A: "GENERIC_5A",
  CREATE_ACCOUNT: "CREATE_ACCOUNT"
};
exports.RECAPTCHA_ACTIONS = RECAPTCHA_ACTIONS;
var CAPTCHA_STARTED = "auth/containers/Captcha/CAPTCHA_STARTED";
exports.CAPTCHA_STARTED = CAPTCHA_STARTED;
var CAPTCHA_CHALLENGE_OPENED = "auth/containers/Captcha/CAPTCHA_CHALLENGE_OPENED";
exports.CAPTCHA_CHALLENGE_OPENED = CAPTCHA_CHALLENGE_OPENED;
var CAPTCHA_COMPLETED = "auth/containers/Captcha/CAPTCHA_COMPLETED";
exports.CAPTCHA_COMPLETED = CAPTCHA_COMPLETED;